import React, { createContext, useState, useEffect, useCallback } from 'react';
import { getInitialLanguage, saveLanguage, LANGUAGES } from './index';

// Create context
export const LanguageContext = createContext({
  language: 'ko',
  setLanguage: () => {},
  languages: LANGUAGES
});

/**
 * Language Provider Component
 * Manages global language state and persistence
 */
export const LanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState(getInitialLanguage());

  // Handle language change
  const setLanguage = useCallback((newLanguage) => {
    if (LANGUAGES[newLanguage]) {
      setLanguageState(newLanguage);
      saveLanguage(newLanguage);
      
      // Dispatch custom event for components that need to react to language changes
      window.dispatchEvent(new CustomEvent('languageChanged', { detail: newLanguage }));
    } else {
      console.warn(`Attempted to set unsupported language: ${newLanguage}`);
    }
  }, []);

  // Initialize language on mount
  useEffect(() => {
    const initialLang = getInitialLanguage();
    if (initialLang !== language) {
      setLanguageState(initialLang);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- sync stored language on mount only
  }, []);

  const value = {
    language,
    setLanguage,
    languages: LANGUAGES
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

